import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../../../utils/formatDate";
import { Button, Popconfirm } from "antd";
import { startUpdateBotonesCambioRol } from "../../../../../context/actions/ptActions";

export const CambioRol = () => {
  const dispatch = useDispatch();
  const {
    fechaCambioRol,
    cambioRol,
    confirmacionCambioRol,
    fechaConfirmacionCambioRol,
  } = useSelector((state) => state.ptReducer.ptDetalle.servicioPT);

  const submit = (tipo) => dispatch(startUpdateBotonesCambioRol(tipo));

  //
  return (
    <div className="SmallCard">
      <div>Cambio de Rol</div>

      {cambioRol ? (
        <div>{formatDate(fechaCambioRol)}</div>
      ) : (
        <div>
          <Popconfirm
            onConfirm={() => submit("CambioRol")}
            title="¿Está seguro de establecer estatus?"
          >
            <Button type="link">Establecer</Button>
          </Popconfirm>
        </div>
      )}
      <hr />

      {cambioRol && (
        <>
          <div>Confirmado</div>
          {confirmacionCambioRol ? (
            <div>{formatDate(fechaConfirmacionCambioRol)}</div>
          ) : (
            <div>
              <Popconfirm
                onConfirm={() => submit("ConfirmacionCambioRol")}
                title="¿Está seguro de establecer estatus?"
              >
                <Button type="link">Confirmar</Button>
              </Popconfirm>
            </div>
          )}
        </>
      )}
    </div>
  );
};
